export default "__VITE_ASSET__DGBZoF3C__"